"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeeSheetAvailable = void 0;
const regions_1 = require("../regions");
const isTeeSheetAvailable = async (supabase, config) => {
    // to work this out i need the course policy on advanced booking limits
    if (!config.course?.id || !config?.where_when_who?.region_id)
        return false;
    const { data: course, error: course_error } = await supabase
        .from("courses")
        .select("policies")
        .eq("id", config.course.id)
        .single();
    if (course_error) {
        // cannot get the course policies, so we assume that the tee sheet is available
        return false;
    }
    const region = (await (0, regions_1.getRegion)(supabase, config?.where_when_who?.region_id));
    if (!region)
        return false;
    const course_policies = course?.policies;
    const { advance_booking } = course_policies;
    // if there is no advance booking policy, then we can assume that the tee sheet is available
    if (!advance_booking || advance_booking.enabled !== "YES")
        return true;
    const weekend_days = region?.weekend_days;
    const weekend_limit = advance_booking.weekend_ph;
    const weekday_limit = advance_booking.weekday;
    const date_of_play = config.where_when_who.date;
    // this is the weekend_days format: {"fri": false, "mon": false, "sat": true, "sun": true, "thu": false, "tue": false, "wed": false}
    // based on the date_of_play can you determine if the date is a weekend or weekday
    const date = new Date(date_of_play);
    const day = date.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    const days = {
        sun: day === 0,
        mon: day === 1,
        tue: day === 2,
        wed: day === 3,
        thu: day === 4,
        fri: day === 5,
        sat: day === 6,
    };
    // Check if the play date is on a weekend based on the region's weekend_days configuration
    const isWeekend = Object.entries(weekend_days).some(([dayKey, isWeekendDay]) => {
        return isWeekendDay && days[dayKey];
    });
    // Calculate the booking limit based on whether it's a weekend or weekday
    const applicable_limit = isWeekend ? weekend_limit : weekday_limit;
    if (!applicable_limit)
        return true;
    // Calculate the number of days between today and the play date
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate day calculation
    const play_date = new Date(date_of_play);
    play_date.setHours(0, 0, 0, 0); // Reset time to start of day
    // Calculate days difference
    const time_difference = play_date.getTime() - today.getTime();
    const days_difference = Math.ceil(time_difference / (1000 * 3600 * 24));
    // Check if the booking is within the advance booking limit
    return days_difference <= applicable_limit;
};
exports.isTeeSheetAvailable = isTeeSheetAvailable;
